module.exports = __webpack_public_path__ + "html/404_bafb4a95032c40a7b1b9af718a95eb4e.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/404.html
// module id = mWZi
// module chunks = 154